export default __webpack_public_path__ + "static/img_5-5f6491432be7112a2dffb3190b391fc5.webp";